import { TextInput } from '@client/new/pages/promotions/view/components/TextInput';
import { Textarea } from '@design-system/components/textarea/textarea';
import { Col, Row } from '@design-system/components/grid/grid';
import * as styles from './Tabata.css';
import { useHIITVM } from '../../view-model/workout.viewModel';
import { HIITVM } from '../../view-model/workouts.domain';
import { ExerciseRenderer } from './Workout';
import { AutoplayedActions } from './common/AutoplayedActions';
import { InfoBox } from './common/InfoBox';
import { Typography } from '@design-system/components/typography/typography';
import { Tooltip } from '@design-system/components/tooltip/tooltip';
import { workoutVM } from '../../../workout/WorkoutEdit';
import { Errors } from '@client/new/pages/promotions/view/components/Errors';
import { MenuSelect } from '@client/new/pages/promotions/view/components/MenuSelect';
import { defaults } from '../../view-model/workout.schema';
import { TimeInputWithControls } from '@design-system/components/time-input';

// todo: define type for different HIIT goals
const HIITForm = (p: HIITVM) => {
  const vm = workoutVM.useValue();
  return (
    <Row className={styles.basicForm} gap="l">
      <Col>
        <TextInput {...p.register('name')} required label="Title" />
        <Textarea
          {...p.register('description')}
          label="Description"
          style={{ minHeight: 128 }}
        />
      </Col>
      <Col gap="l">
        <Row
          style={{ display: 'grid', gridTemplateColumns: '1fr 135px' }}
          alignCenter
        >
          <Typography variant="body" size="medium">
            Goal:
          </Typography>
          <Col>
            <MenuSelect
              options={new Array(defaults.rounds.max).fill(0).map((_, i) => ({
                label: `${i + 1}`,
                value: i + 1,
              }))}
              {...p.register('rounds')}
              value={p.rounds}
            />
          </Col>
        </Row>
        <Row spreadEvenly>
          <Typography variant="body" size="medium">
            Duration:
          </Typography>
          <Typography variant="body" size="medium" fontWeight="normal">
            <Tooltip
              title="The duration here is calculated based on the workout and rest times for each exercise "
              variant="dark"
              arrow
              tooltipProps={{
                maxWidth: 157,
              }}
            >
              <span>{vm.getDuration(p.id)}</span>
            </Tooltip>
          </Typography>
        </Row>
        <Row>
          <InfoBox title="How does it work?" collapsible defaultOpen={false}>
            Pick how long you want your users to do an exercise, how long they
            should rest in between, and how many sets they'll do. You'll also be
            able to define a longer rest at the end of each exercise. These
            values can be changed later on.
          </InfoBox>
        </Row>
        <Row>
          <Col>
            <Typography variant="body" size="medium">
              <Tooltip
                variant="dark"
                arrow
                tooltipProps={{
                  maxWidth: 157,
                }}
                placement="left"
                title="This rest will appear between rounds"
              >
                <span>Extra rest</span>
              </Tooltip>
            </Typography>
            <Typography variant="body" size="small" fontWeight="normal">
              Enter a time or use the +/- controls or input value. The time will
              increase in 10-second steps.
            </Typography>
            <TimeInputWithControls {...p.register('longRest')} />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export const HIIT: ExerciseRenderer = (p) => {
  const workout = workoutVM.useValue();
  const hiit = useHIITVM(workout, p.id);
  return (
    <Col className={styles.content}>
      <Errors data={hiit.errors} />
      <HIITForm {...hiit} />
      <div className={styles.list}>{p.children ? p.children : null}</div>
      <AutoplayedActions id={p.id} />
    </Col>
  );
};
